var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "17",
        height: "17",
        viewBox: "0 0 17 17",
        fill: "none",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M15.7375 1.51328C15.0531 0.828906 13.9469 0.828906 13.2625 1.51328L12.3219 2.45078L15.3813 5.51016L16.3219 4.56953C17.0063 3.88516 17.0063 2.77891 16.3219 2.09453L15.7375 1.51328ZM6.3875 8.38828C6.19687 8.57891 6.05 8.81328 5.96562 9.07266L5.04063 11.8477C4.95 12.1164 5.02188 12.4133 5.22188 12.6164C5.42188 12.8195 5.71875 12.8883 5.99062 12.7977L8.76562 11.8727C9.02188 11.7883 9.25625 11.6414 9.45 11.4508L14.6781 6.21953L11.6156 3.15703L6.3875 8.38828ZM4 2.83516C2.34375 2.83516 1 4.17891 1 5.83516V13.8352C1 15.4914 2.34375 16.8352 4 16.8352H12C13.6562 16.8352 15 15.4914 15 13.8352V10.8352C15 10.282 14.5531 9.83516 14 9.83516C13.4469 9.83516 13 10.282 13 10.8352V13.8352C13 14.3883 12.5531 14.8352 12 14.8352H4C3.44688 14.8352 3 14.3883 3 13.8352V5.83516C3 5.28203 3.44688 4.83516 4 4.83516H7C7.55312 4.83516 8 4.38828 8 3.83516C8 3.28203 7.55312 2.83516 7 2.83516H4Z",
          fill: "#717986",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }